<template>
  <ELYXModalBox>
    <ELYXModalHeader>Something went wrong</ELYXModalHeader>
    <ELYXModalText> It looks like something's not quite right. Please refresh the page and try again. </ELYXModalText>

    <ELYXModalText> If that does not resolve the issue, please contact us at support@cofocus.one </ELYXModalText>

    <ELYXModalButton @click="closeModal">Continue</ELYXModalButton>
  </ELYXModalBox>
</template>

<script>
import ELYXModalBox from "../../ELYXComponents/ELYXModalBox.vue";
import ELYXModalHeader from "../../ELYXComponents/ELYXModalHeader.vue";
import ELYXModalText from "../../ELYXComponents/ELYXModalText.vue";
import ELYXModalButton from "../../ELYXComponents/ELYXModalButton.vue";

export default {
  components: {
    ELYXModalBox,
    ELYXModalHeader,
    ELYXModalText,
    ELYXModalButton,
  },

  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
